import { useLocation } from "react-router";
import { useValidateLogin } from "../../hooks/login/useValidateLogin";
import { LoginForm } from "../login/LoginForm";
import { DirectLoginWithoutPassword } from "../login/DirectLoginWithoutPassword";
import {
  ReportingMelcoMachineStatisticsModelsValidateResponse,
  parseAPIErrorResponse,
} from "melco-shared-logic";
import { useEffect, useState } from "react";
import { DisplayErrors } from "../helper/DisplayErrors";

export const ValidateForm = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const accessTokenInUrl = searchParams.get("access_token");
  const validateLogin = useValidateLogin();

  const [errors, setErrors] = useState<any[]>();
  const [validateLoginResponse, setValidateLoginResponse] = useState<
    ReportingMelcoMachineStatisticsModelsValidateResponse | undefined
  >();
  const [loading, setLoading] = useState<boolean>(true);

  const onSubmit = async () => {
    setErrors(undefined);
    try {
      setLoading(true);
      const validateLoginResponse = await validateLogin({
        access_token: accessTokenInUrl,
      });
      setLoading(false);
      //setErrors(undefined);
      setValidateLoginResponse(validateLoginResponse);
    } catch (error) {
      setLoading(false);
      const apiErrors = await parseAPIErrorResponse(error);
      setErrors(apiErrors);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    onSubmit();
  }, []);

  return (
    <>
      {errors && errors.length > 0 && <DisplayErrors errors={errors} />}

      {validateLoginResponse && validateLoginResponse?.is_password_required && (
        <LoginForm
          view_id={validateLoginResponse?.view_id ?? undefined}
          access_token={accessTokenInUrl}
        />
      )}

      {validateLoginResponse &&
        !validateLoginResponse?.is_password_required && (
          <DirectLoginWithoutPassword
            view_id={validateLoginResponse?.view_id ?? undefined}
            access_token={accessTokenInUrl}
          />
        )}
    </>
  );
};
